<div class="card chart-card h-100">
  <h2 class="font-18 font-primary--b text-center main-title">
    {{ "questionary.home-page-old.my-progress-title" | translate }}
  </h2>
  <section
    class="circle-wrapper d-flex justify-content-center align-items-center"
  >
    <circle-progress
      [percent]="userProgress.progress_percentage"
      [options]="circleProgressOption"
    >
    </circle-progress>
  </section>
  <ul class="progress-wrapper" *ngIf="userProgress.progress_percentage !== 0">
    <li class="item">
      <span class="title">
        {{ "questionary.home-page-old.my-progress-chapters" | translate }}
      </span>
      <span class="progress-values"
        >{{ userProgress.children_completed_1 }}/{{
          userProgress.children_total_1
        }}</span
      >
    </li>
    <li class="item">
      <span class="title">
        {{ "questionary.home-page-old.my-progress-activities" | translate }}
      </span>
      <span class="progress-values"
        >{{ userProgress.children_completed_4 }}/{{
          userProgress.children_total_4
        }}</span
      >
    </li>
  </ul>
</div>
